import { render, staticRenderFns } from "./MultipleChoiceExam.vue?vue&type=template&id=eb04d3f4&scoped=true&"
import script from "./MultipleChoiceExam.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceExam.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceExam.vue?vue&type=style&index=0&id=eb04d3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb04d3f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VAlert,VBtn,VCheckbox,VDivider,VExpandTransition,VIcon,VOverlay})
